import { render, staticRenderFns } from "./InvoicesDetailsGrid.vue?vue&type=template&id=68924e67&scoped=true&"
import script from "./InvoicesDetailsGrid.vue?vue&type=script&lang=ts&"
export * from "./InvoicesDetailsGrid.vue?vue&type=script&lang=ts&"
import style0 from "./InvoicesDetailsGrid.vue?vue&type=style&index=0&id=68924e67&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68924e67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68924e67')) {
      api.createRecord('68924e67', component.options)
    } else {
      api.reload('68924e67', component.options)
    }
    module.hot.accept("./InvoicesDetailsGrid.vue?vue&type=template&id=68924e67&scoped=true&", function () {
      api.rerender('68924e67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/InvoicesDetailsGrid.vue"
export default component.exports